import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7247da46"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"player-placeholder\" data-v-7247da46><div class=\"player-placeholder-top\" data-v-7247da46></div><div class=\"player-placeholder-bottom\" data-v-7247da46><div class=\"player-placeholder-bottom-left\" data-v-7247da46></div><div class=\"player-placeholder-bottom-right\" data-v-7247da46></div></div></div>", 1);
const _hoisted_2 = {
  class: "player"
};
const _hoisted_3 = {
  class: "player-primary-area"
};
const _hoisted_4 = ["data-screen", "data-ctrl-hidden"];
const _hoisted_5 = {
  class: "player-video-perch"
};
const _hoisted_6 = {
  class: "player-video-wrap"
};
const _hoisted_7 = ["src", "loop"];
const _hoisted_8 = {
  class: "player-state"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "player-state-play"
}, null, -1));
const _hoisted_10 = {
  class: "player-state-buff-icon"
};
const _hoisted_11 = {
  class: "player-state-buff-text"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "正在缓冲...", -1));
const _hoisted_13 = {
  class: "player-top-wrap"
};
const _hoisted_14 = {
  class: "player-top-left"
};
const _hoisted_15 = {
  class: "player-title"
};
const _hoisted_16 = {
  key: 0
};
const _hoisted_17 = ["src"];
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1700578364917",
  class: "icon player-follow-icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "3687",
  width: "12",
  height: "12"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M512 972.8a51.2 51.2 0 0 1-51.2-51.2V102.4a51.2 51.2 0 0 1 102.4 0v819.2a51.2 51.2 0 0 1-51.2 51.2z",
  "p-id": "3688",
  fill: "#FFFFFF"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M921.6 512H102.4",
  fill: "#FFFFFF",
  "p-id": "3689"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M921.6 563.2H102.4a51.2 51.2 0 0 1 0-102.4h819.2a51.2 51.2 0 0 1 0 102.4z",
  "p-id": "3690",
  fill: "#FFFFFF"
})], -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "player-follow-text"
}, "关注", -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "player-control-mask"
}, null, -1));
const _hoisted_21 = {
  class: "player-control-entity"
};
const _hoisted_22 = {
  class: "player-control-top"
};
const _hoisted_23 = {
  class: "player-control-bottom"
};
const _hoisted_24 = {
  class: "player-control-bottom-left"
};
const _hoisted_25 = {
  key: 0,
  class: "player-ctrl-btn player-ctrl-prev"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "player-ctrl-btn-icon"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "common-svg-icon"
}, [/*#__PURE__*/_createElementVNode("svg", {
  t: "1700643760528",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "3961",
  width: "22",
  height: "22"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M343.95259221 459.21031851L712.1969664 178.16268117c43.70934215-33.36821646 106.7137627-2.19481771 106.71376157 52.78865294v562.09527581c0 54.98347065-63.00442055 86.15892423-106.71376157 52.79070891L343.95259221 564.78968149c-34.81704221-26.57620082-34.81704221-79.00316103 0-105.57936298zM201.32437789 817.83284281V443.37392867v-187.23562268c0-22.33247517-6.71803278-68.8079451 19.40810752-86.29044906 29.04023267-19.42043762 67.97975097 1.37689885 67.97975096 36.31724544v561.69453681c0 22.33247517 6.73036288 68.80589027-19.39577628 86.29044907-29.05256391 19.42043762-67.99208221-1.37895367-67.9920822-36.31724544z",
  fill: "#FFFFFF",
  "p-id": "3962"
})])])], -1));
const _hoisted_27 = [_hoisted_26];
const _hoisted_28 = {
  class: "player-ctrl-btn player-ctrl-play"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "common-svg-icon"
}, [/*#__PURE__*/_createElementVNode("svg", {
  t: "1700644047374",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4206",
  width: "22",
  height: "22"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M847.52000001 429.80266667L344.50133334 101.152c-78.176-45.184-142.21866667-8.18133333-142.21866667 82.13333333v657.22666667c0 90.368 64.04266667 127.30666667 142.21866667 82.19733333L847.52000001 594.13333333c78.25066667-45.25866667 78.25066667-119.14666667 0-164.33066666z m0 0",
  fill: "#FFFFFF",
  "p-id": "4207"
})])], -1));
const _hoisted_30 = [_hoisted_29];
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "common-svg-icon"
}, [/*#__PURE__*/_createElementVNode("svg", {
  t: "1700644104462",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4447",
  width: "22",
  height: "22"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M735.9 64.9c-51.2 0-96 44.7-96 95.8v702.6c0 51.1 44.8 95.8 96 95.8s96-44.7 96-95.8V160.7c0-51.1-44.8-95.8-96-95.8z m-447.8 0c-51.2 0-96 44.7-96 95.8v702.6c0 51.1 44.8 95.8 96 95.8s96-44.7 96-95.8V160.7c-0.1-51.1-44.9-95.8-96-95.8z",
  "p-id": "4448",
  fill: "#FFFFFF"
})])], -1));
const _hoisted_32 = [_hoisted_31];
const _hoisted_33 = {
  key: 1,
  class: "player-ctrl-btn player-ctrl-next"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "player-ctrl-btn-icon"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "common-svg-icon"
}, [/*#__PURE__*/_createElementVNode("svg", {
  t: "1700644237259",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4688",
  width: "22",
  height: "22"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M680.0474078 564.78968149L311.8030336 845.83731883c-43.70934215 33.36821646-106.7137627 2.19481771-106.71376157-52.78865295l0-562.0952758c0-54.98347065 63.00442055-86.15892423 106.71376157-52.79070891L680.0474078 459.21031851c34.81704221 26.57620082 34.81704221 79.00316103 0 105.57936298zM822.67562211 206.16715719L822.67562211 580.62607133l0 187.23562268c0 22.33247517 6.71803278 68.8079451-19.40810752 86.29044906-29.04023267 19.42043762-67.97975097-1.37689886-67.97975096-36.31724544l0-561.69453681c0-22.33247517-6.73036288-68.80589027 19.39577628-86.29044907 29.05256391-19.42043761 67.99208221 1.37895367 67.9920822 36.31724544z",
  fill: "#FFFFFF",
  "p-id": "4689"
})])])], -1));
const _hoisted_35 = [_hoisted_34];
const _hoisted_36 = {
  class: "player-ctrl-btn player-ctrl-time"
};
const _hoisted_37 = {
  class: "player-ctrl-time-label"
};
const _hoisted_38 = {
  class: "player-ctrl-time-current"
};
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "player-ctrl-time-divide"
}, "/", -1));
const _hoisted_40 = {
  class: "player-ctrl-time-duration"
};
const _hoisted_41 = {
  class: "player-control-bottom-center"
};
const _hoisted_42 = {
  key: 0,
  class: "player-sending-bar"
};
const _hoisted_43 = {
  class: "player-dm-root"
};
const _hoisted_44 = {
  key: 0,
  t: "1700487450055",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "7051",
  width: "100%",
  height: "100%"
};
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M673.10933333 432.64H616.6755552v40.50488854h56.43377813v-40.50488854z m-106.95111146 0h-53.7031104v40.50488854h53.7031104v-40.50488854z m0 82.37511147h-53.7031104v38.22933333h53.7031104v-38.22933333z m106.95111146 0H616.6755552v38.22933333h56.43377813v-38.22933333z m-27.30666666-206.16533333l48.69688853 17.29422186c-10.0124448 23.66577813-21.39022187 44.60088853-33.67822187 63.2604448h57.344v207.0755552h-101.94488853v37.77422187h121.0595552v47.78666667l-0.45511147 0.45511146h-120.60444373l-0.45511147-0.45511146c-30.9475552-33.22311147-82.83022187-35.49866667-116.5084448-4.5511104l-5.00622186 5.00622186h-46.42133334v-48.24177813h117.41866667v-37.77422187h-99.66933333v-207.0755552h59.1644448a386.38933333 386.38933333 0 0 0-36.864-60.9848896l46.87644373-15.92888853c13.65333333 19.56977813 26.3964448 40.50488853 36.4088896 62.80533333l-30.94755627 13.65333334h68.26666667c14.5635552-24.576 26.3964448-51.88266667 37.31911147-80.0995552z m-212.08177814 21.84533333v151.552H344.97422187l-6.82666667 66.44622187h98.75911147c0 84.65066667-3.18577813 141.0844448-7.73688854 169.7564448-5.9164448 28.672-30.9475552 44.14577813-76.00355626 47.3315552-12.74311147 0-25.48622187-0.91022187-39.59466667-1.8204448l-13.19822187-47.78666667c12.74311147 1.36533333 26.8515552 2.2755552 40.50488854 2.27555627 24.576 0 38.6844448-7.73688853 41.87022293-23.66577814 3.64088853-15.92888853 5.46133333-49.60711147 5.46133333-101.94488853H285.35466667l13.65333333-154.28266667h83.28533333v-63.71555626H289.90577813v-43.69066667h143.8151104v-0.4551104z",
  "p-id": "7052"
}, null, -1));
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M792.9856 171.40622187a182.0444448 182.0444448 0 0 1 181.8624 172.94222293l0.1820448 9.10222187v113.77777813a45.51111147 45.51111147 0 0 1-90.7036448 5.27928854l-0.31857813-5.3248V353.45066667a91.02222187 91.02222187 0 0 0-84.1955552-90.7491552l-6.82666667-0.27306667H229.28497813a91.02222187 91.02222187 0 0 0-90.79466666 84.24106667l-0.22755627 6.82666667v427.30382186a91.02222187 91.02222187 0 0 0 84.19555627 90.79466667l6.82666666 0.2275552h300.55537707a45.51111147 45.51111147 0 0 1 5.3248 90.7036448l-5.3248 0.31857813H229.28497813a182.0444448 182.0444448 0 0 1-181.8168896-172.94222293l-0.2275552-9.10222187v-427.34933333a182.0444448 182.0444448 0 0 1 172.94222187-181.81688853l9.10222293-0.22755627h563.70062187z",
  "p-id": "7053"
}, null, -1));
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M286.76551147 48.2076448a45.51111147 45.51111147 0 0 1 60.07466666-3.77742293l4.27804374 3.77742293 136.53333333 136.53333334a45.51111147 45.51111147 0 0 1-60.07466667 68.17564373l-4.27804373-3.77742187-136.53333333-136.53333333a45.51111147 45.51111147 0 0 1 0-64.39822187z",
  "p-id": "7054"
}, null, -1));
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M715.20711147 48.2076448a45.51111147 45.51111147 0 0 0-60.07466667-3.77742293l-4.2780448 3.77742293-136.53333333 136.53333334a45.51111147 45.51111147 0 0 0 60.07466666 68.17564373l4.2780448-3.77742187 136.53333334-136.53333333a45.51111147 45.51111147 0 0 0 0-64.39822187z",
  "p-id": "7055"
}, null, -1));
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M896.3868448 596.02488854a45.51111147 45.51111147 0 0 1 69.95057707 57.9356448l-3.64088854 4.41457813-245.39591146 260.9152a45.51111147 45.51111147 0 0 1-61.53102187 4.36906667l-4.36906667-3.95946667-118.01031146-122.33386667a45.51111147 45.51111147 0 0 1 61.30346666-67.03786666l4.23253334 3.86844373 84.7872 87.88195627 212.67342293-226.0536896z",
  fill: "#FF6699",
  "p-id": "7056"
}, null, -1));
const _hoisted_50 = [_hoisted_45, _hoisted_46, _hoisted_47, _hoisted_48, _hoisted_49];
const _hoisted_51 = {
  key: 1,
  t: "1700488288201",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "7204",
  width: "100%",
  height: "100%"
};
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M673.10933333 432.64H616.6755552v40.50488854h56.43377813v-40.50488854z m-106.95111146 0h-53.7031104v40.50488854h53.7031104v-40.50488854z m0 82.37511147h-53.7031104v38.22933333h53.7031104v-38.22933333z m106.95111146 0H616.6755552v38.22933333h56.43377813v-38.22933333z m-27.30666666-206.16533333l48.69688853 17.29422186c-10.0124448 23.66577813-21.39022187 44.60088853-33.67822187 63.2604448h57.344v207.0755552h-101.94488853v37.77422187h44.60088853l-15.01866666 48.24177813h-29.58222187l-0.45511147-0.45511146-121.51466666 0.45511146h-46.42133334v-48.24177813h117.41866667v-37.77422187h-99.66933333v-207.0755552h59.1644448a386.38933333 386.38933333 0 0 0-36.864-60.9848896l46.87644373-15.92888853c13.65333333 19.56977813 26.3964448 40.50488853 36.4088896 62.80533333l-30.94755627 13.65333334h68.26666667c14.5635552-24.576 26.3964448-51.88266667 37.31911147-80.0995552z m-212.08177814 21.84533333v151.552H344.97422187l-6.82666667 66.44622187h98.75911147c0 84.65066667-3.18577813 141.0844448-7.73688854 169.7564448-5.9164448 28.672-30.9475552 44.14577813-76.00355626 47.3315552-12.74311147 0-25.48622187-0.91022187-39.59466667-1.8204448l-13.19822187-47.78666667c12.74311147 1.36533333 26.8515552 2.2755552 40.50488854 2.27555627 24.576 0 38.6844448-7.73688853 41.87022293-23.66577814 3.64088853-15.92888853 5.46133333-49.60711147 5.46133333-101.94488853H285.35466667l13.65333333-154.28266667h83.28533333v-63.71555626H289.90577813v-43.69066667h143.8151104v-0.4551104z",
  "p-id": "7205"
}, null, -1));
const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M792.9856 171.40622187a182.0444448 182.0444448 0 0 1 181.8624 172.94222293l0.1820448 9.10222187v79.18933333a45.51111147 45.51111147 0 0 1-90.7036448 5.3248l-0.31857813-5.3248v-79.18933333a91.02222187 91.02222187 0 0 0-84.1955552-90.7491552l-6.82666667-0.27306667H229.28497813a91.02222187 91.02222187 0 0 0-90.79466666 84.24106667l-0.22755627 6.82666667v427.30382186a91.02222187 91.02222187 0 0 0 84.19555627 90.79466667l6.82666666 0.2275552h300.55537707a45.51111147 45.51111147 0 0 1 5.3248 90.7036448l-5.3248 0.31857813H229.28497813a182.0444448 182.0444448 0 0 1-181.8168896-172.94222293l-0.2275552-9.10222187v-427.34933333a182.0444448 182.0444448 0 0 1 172.94222187-181.81688853l9.10222293-0.22755627h563.70062187z",
  "p-id": "7206"
}, null, -1));
const _hoisted_54 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M286.76551147 48.2076448a45.51111147 45.51111147 0 0 1 60.07466666-3.77742293l4.27804374 3.77742293 136.53333333 136.53333334a45.51111147 45.51111147 0 0 1-60.07466667 68.17564373l-4.27804373-3.77742187-136.53333333-136.53333333a45.51111147 45.51111147 0 0 1 0-64.39822187z",
  "p-id": "7207"
}, null, -1));
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M715.20711147 48.2076448a45.51111147 45.51111147 0 0 0-60.07466667-3.77742293l-4.2780448 3.77742293-136.53333333 136.53333334a45.51111147 45.51111147 0 0 0 60.07466666 68.17564373l4.2780448-3.77742187 136.53333334-136.53333333a45.51111147 45.51111147 0 0 0 0-64.39822187z",
  "p-id": "7208"
}, null, -1));
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M785.06666667 490.66666667a227.5555552 227.5555552 0 1 0 0 455.11111147 227.5555552 227.5555552 0 0 0 0-455.11111147z m0 91.02222187a136.53333333 136.53333333 0 1 1 0 273.06666666 136.53333333 136.53333333 0 0 1 0-273.06666666z",
  "p-id": "7209"
}, null, -1));
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M870.94613333 571.99502187a45.51111147 45.51111147 0 0 1 66.7648 61.57653333l-3.8684448 4.18702294-229.28497706 219.31804373a45.51111147 45.51111147 0 0 1-66.7648-61.57653333l3.86844373-4.18702187 229.28497813-219.3635552z",
  "p-id": "7210"
}, null, -1));
const _hoisted_58 = [_hoisted_52, _hoisted_53, _hoisted_54, _hoisted_55, _hoisted_56, _hoisted_57];
const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1700490442936",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "3841",
  width: "100%",
  height: "100%"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M167.25546667 293.9904h-54.61333333c-40.84622222 0-73.95555555-33.10933333-73.95555555-73.95555555s33.10933333-73.95555555 73.95555555-73.95555556h54.61333333c40.84622222 0 73.95555555 33.10933333 73.95555555 73.95555556s-33.10933333 73.95555555-73.95555555 73.95555555zM732.73102222 293.9904h-366.36444444c-40.84622222 0-73.95555555-33.10933333-73.95555555-73.95555555s33.10933333-73.95555555 73.95555555-73.95555556h366.36444444c40.84622222 0 73.95555555 33.10933333 73.95555557 73.95555556s-33.10933333 73.95555555-73.95555557 73.95555555zM367.50435555 589.81262222h-254.86222221c-40.84622222 0-73.95555555-33.10933333-73.95555555-73.95555555s33.10933333-73.95555555 73.95555555-73.95555556h254.86222221c40.84622222 0 73.95555555 33.10933333 73.95555556 73.95555556s-33.10933333 73.95555555-73.95555556 73.95555555zM195.69991111 884.49706667h-83.05777777c-40.84622222 0-73.95555555-33.10933333-73.95555555-73.95555556s33.10933333-73.95555555 73.95555555-73.95555556h83.05777777c40.84622222 0 73.95555555 33.10933333 73.95555556 73.95555556s-33.10933333 73.95555555-73.95555556 73.95555556zM392.53546667 884.49706667h-1.13777778c-40.84622222 0-73.95555555-33.10933333-73.95555556-73.95555556s33.10933333-73.95555555 73.95555556-73.95555556h1.13777778c40.84622222 0 73.95555555 33.10933333 73.95555555 73.95555556s-33.10933333 73.95555555-73.95555555 73.95555556zM995.83075556 599.1424l-106.26844445-184.06968889a67.34392889 67.34392889 0 0 0-58.33386666-33.67822222h-212.5368889a67.35758222 67.35758222 0 0 0-58.33386666 33.67822222l-106.26844443 184.06968889a67.38488889 67.38488889 0 0 0 0 67.35644445l106.26844443 184.06968888a67.34392889 67.34392889 0 0 0 58.33386666 33.67822222h212.54826667c24.064 0 46.29617778-12.83413333 58.33386667-33.67822222l106.26844445-184.06968888a67.35644445 67.35644445 0 0 0-0.01137778-67.35644445z m-270.87075555 108.97635555c-41.58577778 0-75.29813333-33.71235555-75.29813334-75.29813333 0-41.58577778 33.71235555-75.29813333 75.29813334-75.29813333 41.58577778 0 75.29813333 33.71235555 75.29813332 75.29813333 0 41.58577778-33.71235555 75.29813333-75.29813332 75.29813333z",
  "p-id": "3842"
})], -1));
const _hoisted_60 = {
  class: "player-dm-setting-wrap"
};
const _hoisted_61 = {
  class: "player-dm-setting-box v-ui v-ui-panel v-ui-dark"
};
const _hoisted_62 = {
  class: "v-ui-area"
};
const _hoisted_63 = {
  class: "v-ui-panel-wrap",
  style: {
    "width": "320px",
    "height": "78px"
  }
};
const _hoisted_64 = {
  class: "v-ui-panel-move",
  style: {
    "width": "586px",
    "transform": "translateX(0px)"
  }
};
const _hoisted_65 = {
  class: "v-ui-panel-item v-ui-panel-item-active",
  style: {
    "width": "320px",
    "height": "78px"
  }
};
const _hoisted_66 = {
  class: "player-dm-setting-left"
};
const _hoisted_67 = {
  class: "player-dm-setting-left-opacity"
};
const _hoisted_68 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "player-dm-setting-left-title"
}, "不透明度", -1));
const _hoisted_69 = {
  class: "player-dm-setting-left-content"
};
const _hoisted_70 = {
  class: "v-ui",
  style: {
    "height": "12px"
  }
};
const _hoisted_71 = {
  class: "v-ui-area"
};
const _hoisted_72 = {
  class: "player-dm-setting-left-value"
};
const _hoisted_73 = {
  class: "player-dm-setting-left-speed"
};
const _hoisted_74 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "player-dm-setting-left-title"
}, "弹幕速度", -1));
const _hoisted_75 = {
  class: "player-dm-setting-left-content",
  style: {
    "height": "22px"
  }
};
const _hoisted_76 = {
  class: "dm-speed-items"
};
const _hoisted_77 = {
  key: 0,
  class: "player-dm-inputbar"
};
const _hoisted_78 = {
  class: "player-video-inputbar-wrap"
};
const _hoisted_79 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1700493799646",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "6734",
  width: "20",
  height: "20"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M220.36510341 728.70570667h139.03341036l57.78818844-140.5868563h226.4147437l54.9143135 140.5868563h146.25693392L584.41515614 45.96622222H480.64496829l-260.27986488 682.73948445zM609.81399703 473.94057482H447.01286399L530.43291021 234.70990222 609.81399703 474.01824711zM166.30518518 819.65996563v136.54789689h728.17777778V819.58229333H166.30518518z",
  "p-id": "6735"
})], -1));
const _hoisted_80 = {
  class: "player-mode-selection-container"
};
const _hoisted_81 = {
  class: "player-mode-selection-panel"
};
const _hoisted_82 = {
  class: "player-mode-selection-row"
};
const _hoisted_83 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row-title"
}, "字号", -1));
const _hoisted_84 = {
  class: "row-selection"
};
const _hoisted_85 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "selection-name"
}, "小", -1));
const _hoisted_86 = [_hoisted_85];
const _hoisted_87 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "selection-name"
}, "标准", -1));
const _hoisted_88 = [_hoisted_87];
const _hoisted_89 = {
  class: "player-mode-selection-row"
};
const _hoisted_90 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row-title"
}, "模式", -1));
const _hoisted_91 = {
  class: "row-selection"
};
const _hoisted_92 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "selection-icon"
}, [/*#__PURE__*/_createElementVNode("svg", {
  t: "1700749596256",
  class: "icon",
  viewBox: "0 0 1192 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "3991"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M1067.17373094 1051.22149218H111.25014969C67.48417906 1051.22149218 32 1015.52238843 32 971.42686593V175.80179062C32 131.72776124 67.81373094 95.99999999 111.25014969 95.99999999h955.92358125c43.77313406 0 79.25731312 35.69910469 79.25731406 79.80179062v795.62507532c0 44.06686594-35.82089531 79.79462719-79.25731406 79.79462625z m-119.74925344-358.208955H390.208955a39.83283563 39.83283563 0 0 0-39.80417906 39.80417906A39.81850781 39.81850781 0 0 0 390.208955 772.61373093h557.2155225a39.81134344 39.81134344 0 0 0 39.79701469-39.79701469 39.81850781 39.81850781 0 0 0-39.79701469-39.80417906z m39.79701469-119.39820844a39.81850781 39.81850781 0 0 0-39.79701469-39.80417906H748.41791a39.82567125 39.82567125 0 0 0-39.80417906 39.80417906A39.81850781 39.81850781 0 0 0 748.41791 613.41134343h199.0065675a39.81134344 39.81134344 0 0 0 39.79701469-39.79701469z m-398.00596969-39.80417906H509.61432875a39.82567125 39.82567125 0 0 0-39.80417906 39.80417906 39.81850781 39.81850781 0 0 0 39.80417906 39.79701469h79.60119375a39.81134344 39.81134344 0 0 0 39.79701469-39.79701469 39.81850781 39.81850781 0 0 0-39.79701469-39.80417906z m398.00596969-119.40537375a39.81134344 39.81134344 0 0 0-39.79701469-39.79701469h-716.41791a39.81850781 39.81850781 0 0 0-39.80417906 39.79701469A39.82567125 39.82567125 0 0 0 231.0065675 454.20895499h716.41791a39.81850781 39.81850781 0 0 0 39.79701469-39.80417906z",
  "p-id": "3992"
})])], -1));
const _hoisted_93 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "selection-name"
}, "滚动", -1));
const _hoisted_94 = [_hoisted_92, _hoisted_93];
const _hoisted_95 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "selection-icon"
}, [/*#__PURE__*/_createElementVNode("svg", {
  t: "1700749716948",
  class: "icon",
  viewBox: "0 0 1192 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4232"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M1066.82268688 95.99999999c43.93791 0 79.60835812 35.67044813 79.60835812 79.60119375v796.01910469c0 43.93791-35.67044813 79.60119375-79.60835812 79.60119375H111.60119375C67.67044813 1051.22149218 32 1015.55820937 32 971.62029843V175.60119374C32 131.67044812 67.67044813 95.99999999 111.60119375 95.99999999h955.22149312zM668.81671625 374.60776124H231.0065675a39.81850781 39.81850781 0 0 0-39.80417906 39.79701469A39.82567125 39.82567125 0 0 0 231.0065675 454.20895499h437.81014875a39.81850781 39.81850781 0 0 0 39.79701469-39.80417906 39.81134344 39.81134344 0 0 0-39.79701469-39.79701469z m238.80358219 0h-79.60119375a39.81134344 39.81134344 0 0 0-39.79701469 39.79701469A39.81850781 39.81850781 0 0 0 828.01910469 454.20895499h79.60119375a39.82567125 39.82567125 0 0 0 39.80417906-39.80417906 39.81850781 39.81850781 0 0 0-39.80417906-39.79701469z m79.60119375-119.40537281a39.81134344 39.81134344 0 0 0-39.79701469-39.79701563h-716.41791a39.81850781 39.81850781 0 0 0-39.80417906 39.79701563 39.83283563 39.83283563 0 0 0 39.80417906 39.80417906h716.41791a39.81850781 39.81850781 0 0 0 39.79701469-39.80417906z",
  "p-id": "4233"
})])], -1));
const _hoisted_96 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "selection-name"
}, "顶部", -1));
const _hoisted_97 = [_hoisted_95, _hoisted_96];
const _hoisted_98 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "selection-icon"
}, [/*#__PURE__*/_createElementVNode("svg", {
  t: "1700749744954",
  class: "icon",
  viewBox: "0 0 1192 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4427"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M1066.82985031 95.99999999c43.93791 0 79.59403031 35.66328375 79.59403031 79.60119375v796.01910469c0 43.94507438-35.65611938 79.60119375-79.59403031 79.60119375H111.59403031C67.66328375 1051.22149218 32 1015.5653728 32 971.6274628V175.5940303C32 131.66328374 67.66328375 95.99999999 111.60119375 95.99999999h955.22865656z m-119.40537281 756.22209h-716.41791a39.81850781 39.81850781 0 0 0-39.80417906 39.79701469 39.81850781 39.81850781 0 0 0 39.80417906 39.80417906h716.41791a39.81850781 39.81850781 0 0 0 39.79701469-39.80417906 39.81850781 39.81850781 0 0 0-39.79701469-39.79701469zM668.81671625 693.01253718H231.0065675a39.81850781 39.81850781 0 0 0-39.80417906 39.80417906 39.81850781 39.81850781 0 0 0 39.80417906 39.80417906h437.81014875a39.81850781 39.81850781 0 0 0 39.80417906-39.80417906 39.81850781 39.81850781 0 0 0-39.80417906-39.80417906z m238.80358219 0h-79.59402938a39.81850781 39.81850781 0 0 0-39.80417906 39.80417906 39.81850781 39.81850781 0 0 0 39.79701469 39.80417906h79.60119375a39.81850781 39.81850781 0 0 0 39.80417906-39.80417906 39.81850781 39.81850781 0 0 0-39.80417906-39.80417906z",
  "p-id": "4428"
})])], -1));
const _hoisted_99 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "selection-name"
}, "底部", -1));
const _hoisted_100 = [_hoisted_98, _hoisted_99];
const _hoisted_101 = {
  class: "player-mode-selection-row"
};
const _hoisted_102 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row-title"
}, "颜色", -1));
const _hoisted_103 = {
  class: "player-control-bottom-right"
};
const _hoisted_104 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "player-ctrl-quality-result"
}, /*#__PURE__*/_toDisplayString('720P 高清'), -1));
const _hoisted_105 = [_hoisted_104];
const _hoisted_106 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "player-ctrl-eplist-result"
}, "选集", -1));
const _hoisted_107 = [_hoisted_106];
const _hoisted_108 = {
  class: "player-ctrl-playbackrate-result"
};
const _hoisted_109 = {
  class: "player-ctrl-playbackrate-menu"
};
const _hoisted_110 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "player-ctrl-btn-icon"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "common-svg-icon"
}, [/*#__PURE__*/_createElementVNode("svg", {
  t: "1700669811042",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "7338",
  width: "22",
  height: "22"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M882.34150875 504.54345955c0-49.57218555 27.61681646-93.75909188 71.66563872-110.19109768-22.09345317-77.18900202-66.14227541-148.85464074-121.23782427-203.95018957-38.52545897 27.61681646-93.62100781 33.00209567-137.80791415 11.0467266-44.04882225-27.61681646-66.14227541-71.66563872-60.61891213-121.23782427-38.52545897-11.04672658-82.7123653-16.57008987-121.23782427-16.57008988-44.04882225 0-82.7123653 5.5233633-121.23782426 16.57008988 5.5233633 44.04882225-16.57008987 93.62100781-60.61891212 121.23782427s-99.14437109 22.09345317-137.80791414-11.0467266c-55.09554883 55.09554883-99.14437109 126.76118755-121.23782426 203.95018957 44.04882225 16.57008987 71.66563872 60.61891214 71.66563872 110.19109768s-27.61681646 93.62100781-71.66563872 110.19109769c22.09345317 77.18900202 66.14227541 148.85464074 121.23782426 203.95018957 38.52545897-27.61681646 93.62100781-33.00209567 137.80791414-11.0467266 44.04882225 27.61681646 66.14227541 71.66563872 60.61891212 121.23782426 38.52545897 11.04672658 82.7123653 16.57008987 121.23782426 16.5700899 44.04882225 0 82.7123653-5.5233633 121.23782427-16.5700899-5.5233633-44.04882225 16.57008987-93.62100781 60.61891213-121.23782426s99.14437109-22.09345317 137.80791415 11.0467266c55.09554883-55.09554883 99.14437109-126.76118755 121.23782427-203.95018957-44.18690634-16.43200579-71.66563872-60.61891214-71.66563872-110.19109769zM513.10467265 686.40019595c-104.66773438 0-187.3800997-82.7123653-187.38009967-181.8567364 0-99.14437109 82.7123653-181.85673639 187.38009967-181.85673638 104.66773438 0 187.3800997 82.7123653 187.3800997 181.85673638-0.13808409 99.28245518-82.7123653 181.85673639-187.3800997 181.8567364z m0-71.66563871c60.8950803 0 110.19109769-49.29601739 110.19109769-110.19109769 0-60.8950803-49.29601739-110.19109769-110.19109769-110.19109768-60.8950803 0-110.19109769 49.29601739-110.19109768 110.19109768-0.13808409 60.8950803 49.29601739 110.19109769 110.19109768 110.19109769z m0 0",
  fill: "#FFFFFF",
  "p-id": "7339"
})])])], -1));
const _hoisted_111 = {
  class: "player-ctrl-setting-box"
};
const _hoisted_112 = {
  class: "player-ctrl-setting-menu v-ui v-ui-panel v-ui-dark"
};
const _hoisted_113 = {
  class: "v-ui-area"
};
const _hoisted_114 = {
  class: "v-ui-panel-wrap",
  style: {
    "width": "132px",
    "height": "108px"
  }
};
const _hoisted_115 = {
  class: "v-ui-panel-move",
  style: {
    "width": "418px"
  }
};
const _hoisted_116 = {
  class: "v-ui-panel-item v-ui-panel-item-active",
  style: {
    "width": "132px",
    "height": "108px"
  }
};
const _hoisted_117 = {
  class: "player-ctrl-setting-menu-left"
};
const _hoisted_118 = /*#__PURE__*/_createStaticVNode("<div class=\"v-ui-area\" data-v-7247da46><div class=\"v-ui-switch-label\" data-v-7247da46><span class=\"v-ui-switch-name\" data-v-7247da46>洗脑循环</span><span class=\"v-ui-switch-body\" data-v-7247da46><span class=\"v-ui-switch-dot\" data-v-7247da46><span data-v-7247da46></span></span></span></div></div>", 1);
const _hoisted_119 = [_hoisted_118];
const _hoisted_120 = /*#__PURE__*/_createStaticVNode("<div class=\"v-ui-area\" data-v-7247da46><div class=\"v-ui-switch-label\" data-v-7247da46><span class=\"v-ui-switch-name\" data-v-7247da46>自动开播</span><span class=\"v-ui-switch-body\" data-v-7247da46><span class=\"v-ui-switch-dot\" data-v-7247da46><span data-v-7247da46></span></span></span></div></div>", 1);
const _hoisted_121 = [_hoisted_120];
const _hoisted_122 = /*#__PURE__*/_createStaticVNode("<div class=\"v-ui-area\" data-v-7247da46><div class=\"v-ui-switch-label\" data-v-7247da46><span class=\"v-ui-switch-name\" data-v-7247da46>自动切集</span><span class=\"v-ui-switch-body\" data-v-7247da46><span class=\"v-ui-switch-dot\" data-v-7247da46><span data-v-7247da46></span></span></span></div></div>", 1);
const _hoisted_123 = [_hoisted_122];
const _hoisted_124 = {
  class: "common-svg-icon"
};
const _hoisted_125 = {
  key: 0,
  t: "1700670251969",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4236",
  width: "22",
  height: "22"
};
const _hoisted_126 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M225.680461 326.598406c-0.419556-0.019443-0.818645-0.019443-1.237177-0.019443L101.812315 326.578963c-22.753213 0-40.876989 18.24248-40.876989 40.777729l0 286.336424c0 22.534226 18.302855 40.777729 40.876989 40.777729l122.629945 0c0.079818 0 0.119727 0 0.198521 0l0 0.157589 300.289204 194.444551c7.125281 6.108115 16.405645 9.781784 26.526143 9.781784 22.573111 0 40.874943-18.301831 40.874943-40.878013 0-1.87572-0.119727-3.711532-0.360204-5.509481L591.970868 168.58151c0.239454-1.795902 0.360204-3.632737 0.360204-5.509481 0-22.574135-18.302855-40.876989-40.874943-40.876989-9.301853 0-17.884322 3.113921-24.750707 8.343015L225.680461 326.598406zM859.567485 510.524392l91.952248-91.951225c11.495822-11.517311 11.576663-30.558993-0.13917-42.274826-11.795651-11.795651-30.636764-11.755742-42.273802-0.140193l-91.953272 91.953272-91.950202-91.953272c-11.639085-11.616572-30.479175-11.655458-42.275849 0.140193-11.715833 11.715833-11.633968 30.757514-0.13917 42.274826l91.952248 91.951225-91.952248 91.953272c-11.494799 11.515265-11.576663 30.556946 0.13917 42.272779 11.796674 11.796674 30.636764 11.756765 42.275849 0.140193l91.950202-91.951225 91.953272 91.951225c11.636015 11.617595 30.477129 11.657504 42.273802-0.140193 11.715833-11.714809 11.634991-30.757514 0.13917-42.272779L859.567485 510.524392z",
  fill: "#FFFFFF",
  "p-id": "4237"
}, null, -1));
const _hoisted_127 = [_hoisted_126];
const _hoisted_128 = {
  key: 1,
  t: "1700670170727",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "3989",
  width: "22",
  height: "22"
};
const _hoisted_129 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M218.495828 334.609871c-0.390903-0.019443-0.773619-0.019443-1.164522-0.019443L100.022553 334.590428c-21.744233 0-39.087227 17.448394-39.087227 39.001269l0 273.866415c0 21.551852 17.505699 38.999223 39.087227 38.999223l117.308753 0c0.057305 0 0.113587 0 0.171915 0l0 0.153496 287.22056 185.975668c6.824429 5.842055 15.691377 9.354042 25.370831 9.354042 21.590737 0 39.096437-17.505699 39.096437-39.095413 0-1.794879-0.124843-3.551896-0.354064-5.270027L568.836985 183.473685c0.229221-1.718131 0.354064-3.475148 0.354064-5.269004 0-21.590737-17.505699-39.096437-39.096437-39.096437-8.895601 0-17.105586 2.977821-23.682375 7.979742L218.495828 334.609871z",
  fill: "#FFFFFF",
  "p-id": "3990"
}, null, -1));
const _hoisted_130 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M757.858012 953.491133l0.085958 0.075725c123.876332-107.514689 202.211445-266.13329 202.211445-443.041442 0-177.214121-78.603219-336.062965-202.851011-443.61654l-0.11461 0.11461c-4.963035-3.817955-11.17655-6.109138-17.925255-6.109138-16.197914 0-29.322839 13.133112-29.322839 29.321816 0 6.757914 2.28095 12.981662 6.109138 17.926278l-0.333598 0.342808c0.821715 0.706081 1.641383 1.393743 2.462075 2.119267 1.173732 1.202385 2.452865 2.329045 3.817955 3.321652 110.054535 96.710622 179.51349 238.550071 179.51349 396.578224 0 158.02713-69.458955 299.866578-179.51349 396.577201-1.36509 0.99363-2.644223 2.118244-3.817955 3.321652-0.600681 0.533143-1.212618 1.048889-1.822508 1.564635l0.229221 0.230244c-4.152577 5.058203-6.643304 11.530614-6.643304 18.593474 0 16.188704 13.124925 29.321816 29.322839 29.321816C746.317165 960.134437 752.798786 957.651896 757.858012 953.491133z",
  fill: "#FFFFFF",
  "p-id": "3991"
}, null, -1));
const _hoisted_131 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M713.998085 729.35433l0.23843 0.24764c55.380308-56.43022 89.532129-133.76454 89.532129-219.077577 0-85.409229-34.228569-162.800853-89.704045-219.249493l-0.268106 0.267083c-4.886287-3.64604-10.966773-5.821589-17.543561-5.821589-16.197914 0-29.322839 13.133112-29.322839 29.321816 0 6.566556 2.166339 12.657274 5.822612 17.544585l-0.162706 0.170892c0.773619 0.782829 1.547239 1.584078 2.310625 2.38635 0.075725 0.076748 0.152473 0.171915 0.23843 0.248663 43.3626 45.587268 69.983911 107.248629 69.983911 175.132716 0 67.884087-26.621311 129.544425-69.983911 175.131693-0.085958 0.077771-0.162706 0.171915-0.23843 0.24764-0.706081 0.74599-1.422396 1.471514-2.13871 2.214435l0.144286 0.134053c-3.751441 4.926196-5.976108 11.092639-5.976108 17.754363 0 16.188704 13.124925 29.321816 29.322839 29.321816C702.925912 735.328391 709.072913 733.113957 713.998085 729.35433z",
  fill: "#FFFFFF",
  "p-id": "3992"
}, null, -1));
const _hoisted_132 = [_hoisted_129, _hoisted_130, _hoisted_131];
const _hoisted_133 = {
  class: "player-ctrl-volume-box"
};
const _hoisted_134 = {
  class: "player-ctrl-volume-number"
};
const _hoisted_135 = {
  class: "player-ctrl-btn player-ctrl-full"
};
const _hoisted_136 = {
  key: 0
};
const _hoisted_137 = {
  key: 1
};
const _hoisted_138 = {
  class: "common-svg-icon"
};
const _hoisted_139 = {
  key: 0,
  t: "1700682460725",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4481",
  width: "22",
  height: "22"
};
const _hoisted_140 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M992 392h-79.99999969V231.99999969h-160.00000031V152h240v240z m-240 480v-79.99999969h160.00000031v-160.00000031h79.99999969v240h-240zM32 632h79.99999969v160.00000031h160.00000031v79.99999969H32v-240zM272 152v79.99999969H111.99999969v160.00000031H32V152h240z m559.99999969 160.00000031H192.00000031v399.99999938h639.99999938V312.00000031z",
  fill: "#FFFFFF",
  "p-id": "4482"
}, null, -1));
const _hoisted_141 = [_hoisted_140];
const _hoisted_142 = {
  key: 1,
  t: "1700682742461",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4722",
  width: "22",
  height: "22"
};
const _hoisted_143 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M896 128H128a64.07 64.07 0 0 0-64 64v640a64.07 64.07 0 0 0 64 64h768a64.07 64.07 0 0 0 64-64V192a64.07 64.07 0 0 0-64-64zM448 672a32 32 0 0 1-64 0v-50.75L246.63 758.63a32 32 0 0 1-45.26-45.26L338.75 576H288a32 32 0 0 1 0-64h128a31.83 31.83 0 0 1 22.35 9.1l0.43 0.43A31.83 31.83 0 0 1 448 544z m374.63-361.37L685.25 448H736a32 32 0 0 1 0 64H608a31.83 31.83 0 0 1-22.35-9.1c-0.14-0.14-0.29-0.28-0.43-0.43A31.83 31.83 0 0 1 576 480V352a32 32 0 0 1 64 0v50.75l137.37-137.38a32 32 0 0 1 45.26 45.26z",
  fill: "#FFFFFF",
  "p-id": "4723"
}, null, -1));
const _hoisted_144 = [_hoisted_143];
const _hoisted_145 = {
  key: 1
};
const _hoisted_146 = {
  class: "common-svg-icon"
};
const _hoisted_147 = {
  key: 0,
  t: "1700682460725",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4481",
  width: "22",
  height: "22"
};
const _hoisted_148 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M992 392h-79.99999969V231.99999969h-160.00000031V152h240v240z m-240 480v-79.99999969h160.00000031v-160.00000031h79.99999969v240h-240zM32 632h79.99999969v160.00000031h160.00000031v79.99999969H32v-240zM272 152v79.99999969H111.99999969v160.00000031H32V152h240z m559.99999969 160.00000031H192.00000031v399.99999938h639.99999938V312.00000031z",
  fill: "#FFFFFF",
  "p-id": "4482"
}, null, -1));
const _hoisted_149 = [_hoisted_148];
const _hoisted_150 = {
  key: 1,
  t: "1700682742461",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4722",
  width: "22",
  height: "22"
};
const _hoisted_151 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M896 128H128a64.07 64.07 0 0 0-64 64v640a64.07 64.07 0 0 0 64 64h768a64.07 64.07 0 0 0 64-64V192a64.07 64.07 0 0 0-64-64zM448 672a32 32 0 0 1-64 0v-50.75L246.63 758.63a32 32 0 0 1-45.26-45.26L338.75 576H288a32 32 0 0 1 0-64h128a31.83 31.83 0 0 1 22.35 9.1l0.43 0.43A31.83 31.83 0 0 1 448 544z m374.63-361.37L685.25 448H736a32 32 0 0 1 0 64H608a31.83 31.83 0 0 1-22.35-9.1c-0.14-0.14-0.29-0.28-0.43-0.43A31.83 31.83 0 0 1 576 480V352a32 32 0 0 1 64 0v50.75l137.37-137.38a32 32 0 0 1 45.26 45.26z",
  fill: "#FFFFFF",
  "p-id": "4723"
}, null, -1));
const _hoisted_152 = [_hoisted_151];
const _hoisted_153 = {
  class: "player-shadow-progress-area"
};
const _hoisted_154 = {
  class: "player-shadow-progress-schedule-wrap"
};
const _hoisted_155 = {
  class: "player-progress-schedule"
};
const _hoisted_156 = {
  class: "player-sending-area"
};
const _hoisted_157 = {
  class: "player-video-info"
};
const _hoisted_158 = {
  class: "player-video-info-text"
};
const _hoisted_159 = {
  class: "player-dm-root"
};
const _hoisted_160 = {
  key: 0,
  t: "1700487450055",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "7051",
  width: "100%",
  height: "100%"
};
const _hoisted_161 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M673.10933333 432.64H616.6755552v40.50488854h56.43377813v-40.50488854z m-106.95111146 0h-53.7031104v40.50488854h53.7031104v-40.50488854z m0 82.37511147h-53.7031104v38.22933333h53.7031104v-38.22933333z m106.95111146 0H616.6755552v38.22933333h56.43377813v-38.22933333z m-27.30666666-206.16533333l48.69688853 17.29422186c-10.0124448 23.66577813-21.39022187 44.60088853-33.67822187 63.2604448h57.344v207.0755552h-101.94488853v37.77422187h121.0595552v47.78666667l-0.45511147 0.45511146h-120.60444373l-0.45511147-0.45511146c-30.9475552-33.22311147-82.83022187-35.49866667-116.5084448-4.5511104l-5.00622186 5.00622186h-46.42133334v-48.24177813h117.41866667v-37.77422187h-99.66933333v-207.0755552h59.1644448a386.38933333 386.38933333 0 0 0-36.864-60.9848896l46.87644373-15.92888853c13.65333333 19.56977813 26.3964448 40.50488853 36.4088896 62.80533333l-30.94755627 13.65333334h68.26666667c14.5635552-24.576 26.3964448-51.88266667 37.31911147-80.0995552z m-212.08177814 21.84533333v151.552H344.97422187l-6.82666667 66.44622187h98.75911147c0 84.65066667-3.18577813 141.0844448-7.73688854 169.7564448-5.9164448 28.672-30.9475552 44.14577813-76.00355626 47.3315552-12.74311147 0-25.48622187-0.91022187-39.59466667-1.8204448l-13.19822187-47.78666667c12.74311147 1.36533333 26.8515552 2.2755552 40.50488854 2.27555627 24.576 0 38.6844448-7.73688853 41.87022293-23.66577814 3.64088853-15.92888853 5.46133333-49.60711147 5.46133333-101.94488853H285.35466667l13.65333333-154.28266667h83.28533333v-63.71555626H289.90577813v-43.69066667h143.8151104v-0.4551104z",
  "p-id": "7052"
}, null, -1));
const _hoisted_162 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M792.9856 171.40622187a182.0444448 182.0444448 0 0 1 181.8624 172.94222293l0.1820448 9.10222187v113.77777813a45.51111147 45.51111147 0 0 1-90.7036448 5.27928854l-0.31857813-5.3248V353.45066667a91.02222187 91.02222187 0 0 0-84.1955552-90.7491552l-6.82666667-0.27306667H229.28497813a91.02222187 91.02222187 0 0 0-90.79466666 84.24106667l-0.22755627 6.82666667v427.30382186a91.02222187 91.02222187 0 0 0 84.19555627 90.79466667l6.82666666 0.2275552h300.55537707a45.51111147 45.51111147 0 0 1 5.3248 90.7036448l-5.3248 0.31857813H229.28497813a182.0444448 182.0444448 0 0 1-181.8168896-172.94222293l-0.2275552-9.10222187v-427.34933333a182.0444448 182.0444448 0 0 1 172.94222187-181.81688853l9.10222293-0.22755627h563.70062187z",
  "p-id": "7053"
}, null, -1));
const _hoisted_163 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M286.76551147 48.2076448a45.51111147 45.51111147 0 0 1 60.07466666-3.77742293l4.27804374 3.77742293 136.53333333 136.53333334a45.51111147 45.51111147 0 0 1-60.07466667 68.17564373l-4.27804373-3.77742187-136.53333333-136.53333333a45.51111147 45.51111147 0 0 1 0-64.39822187z",
  "p-id": "7054"
}, null, -1));
const _hoisted_164 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M715.20711147 48.2076448a45.51111147 45.51111147 0 0 0-60.07466667-3.77742293l-4.2780448 3.77742293-136.53333333 136.53333334a45.51111147 45.51111147 0 0 0 60.07466666 68.17564373l4.2780448-3.77742187 136.53333334-136.53333333a45.51111147 45.51111147 0 0 0 0-64.39822187z",
  "p-id": "7055"
}, null, -1));
const _hoisted_165 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M896.3868448 596.02488854a45.51111147 45.51111147 0 0 1 69.95057707 57.9356448l-3.64088854 4.41457813-245.39591146 260.9152a45.51111147 45.51111147 0 0 1-61.53102187 4.36906667l-4.36906667-3.95946667-118.01031146-122.33386667a45.51111147 45.51111147 0 0 1 61.30346666-67.03786666l4.23253334 3.86844373 84.7872 87.88195627 212.67342293-226.0536896z",
  fill: "#FF6699",
  "p-id": "7056"
}, null, -1));
const _hoisted_166 = [_hoisted_161, _hoisted_162, _hoisted_163, _hoisted_164, _hoisted_165];
const _hoisted_167 = {
  key: 1,
  t: "1700488288201",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "7204",
  width: "100%",
  height: "100%"
};
const _hoisted_168 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M673.10933333 432.64H616.6755552v40.50488854h56.43377813v-40.50488854z m-106.95111146 0h-53.7031104v40.50488854h53.7031104v-40.50488854z m0 82.37511147h-53.7031104v38.22933333h53.7031104v-38.22933333z m106.95111146 0H616.6755552v38.22933333h56.43377813v-38.22933333z m-27.30666666-206.16533333l48.69688853 17.29422186c-10.0124448 23.66577813-21.39022187 44.60088853-33.67822187 63.2604448h57.344v207.0755552h-101.94488853v37.77422187h44.60088853l-15.01866666 48.24177813h-29.58222187l-0.45511147-0.45511146-121.51466666 0.45511146h-46.42133334v-48.24177813h117.41866667v-37.77422187h-99.66933333v-207.0755552h59.1644448a386.38933333 386.38933333 0 0 0-36.864-60.9848896l46.87644373-15.92888853c13.65333333 19.56977813 26.3964448 40.50488853 36.4088896 62.80533333l-30.94755627 13.65333334h68.26666667c14.5635552-24.576 26.3964448-51.88266667 37.31911147-80.0995552z m-212.08177814 21.84533333v151.552H344.97422187l-6.82666667 66.44622187h98.75911147c0 84.65066667-3.18577813 141.0844448-7.73688854 169.7564448-5.9164448 28.672-30.9475552 44.14577813-76.00355626 47.3315552-12.74311147 0-25.48622187-0.91022187-39.59466667-1.8204448l-13.19822187-47.78666667c12.74311147 1.36533333 26.8515552 2.2755552 40.50488854 2.27555627 24.576 0 38.6844448-7.73688853 41.87022293-23.66577814 3.64088853-15.92888853 5.46133333-49.60711147 5.46133333-101.94488853H285.35466667l13.65333333-154.28266667h83.28533333v-63.71555626H289.90577813v-43.69066667h143.8151104v-0.4551104z",
  "p-id": "7205"
}, null, -1));
const _hoisted_169 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M792.9856 171.40622187a182.0444448 182.0444448 0 0 1 181.8624 172.94222293l0.1820448 9.10222187v79.18933333a45.51111147 45.51111147 0 0 1-90.7036448 5.3248l-0.31857813-5.3248v-79.18933333a91.02222187 91.02222187 0 0 0-84.1955552-90.7491552l-6.82666667-0.27306667H229.28497813a91.02222187 91.02222187 0 0 0-90.79466666 84.24106667l-0.22755627 6.82666667v427.30382186a91.02222187 91.02222187 0 0 0 84.19555627 90.79466667l6.82666666 0.2275552h300.55537707a45.51111147 45.51111147 0 0 1 5.3248 90.7036448l-5.3248 0.31857813H229.28497813a182.0444448 182.0444448 0 0 1-181.8168896-172.94222293l-0.2275552-9.10222187v-427.34933333a182.0444448 182.0444448 0 0 1 172.94222187-181.81688853l9.10222293-0.22755627h563.70062187z",
  "p-id": "7206"
}, null, -1));
const _hoisted_170 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M286.76551147 48.2076448a45.51111147 45.51111147 0 0 1 60.07466666-3.77742293l4.27804374 3.77742293 136.53333333 136.53333334a45.51111147 45.51111147 0 0 1-60.07466667 68.17564373l-4.27804373-3.77742187-136.53333333-136.53333333a45.51111147 45.51111147 0 0 1 0-64.39822187z",
  "p-id": "7207"
}, null, -1));
const _hoisted_171 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M715.20711147 48.2076448a45.51111147 45.51111147 0 0 0-60.07466667-3.77742293l-4.2780448 3.77742293-136.53333333 136.53333334a45.51111147 45.51111147 0 0 0 60.07466666 68.17564373l4.2780448-3.77742187 136.53333334-136.53333333a45.51111147 45.51111147 0 0 0 0-64.39822187z",
  "p-id": "7208"
}, null, -1));
const _hoisted_172 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M785.06666667 490.66666667a227.5555552 227.5555552 0 1 0 0 455.11111147 227.5555552 227.5555552 0 0 0 0-455.11111147z m0 91.02222187a136.53333333 136.53333333 0 1 1 0 273.06666666 136.53333333 136.53333333 0 0 1 0-273.06666666z",
  "p-id": "7209"
}, null, -1));
const _hoisted_173 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M870.94613333 571.99502187a45.51111147 45.51111147 0 0 1 66.7648 61.57653333l-3.8684448 4.18702294-229.28497706 219.31804373a45.51111147 45.51111147 0 0 1-66.7648-61.57653333l3.86844373-4.18702187 229.28497813-219.3635552z",
  "p-id": "7210"
}, null, -1));
const _hoisted_174 = [_hoisted_168, _hoisted_169, _hoisted_170, _hoisted_171, _hoisted_172, _hoisted_173];
const _hoisted_175 = {
  key: 1
};
const _hoisted_176 = {
  key: 0,
  t: "1700487450055",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "7051",
  width: "100%",
  height: "100%"
};
const _hoisted_177 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M673.10933333 432.64H616.6755552v40.50488854h56.43377813v-40.50488854z m-106.95111146 0h-53.7031104v40.50488854h53.7031104v-40.50488854z m0 82.37511147h-53.7031104v38.22933333h53.7031104v-38.22933333z m106.95111146 0H616.6755552v38.22933333h56.43377813v-38.22933333z m-27.30666666-206.16533333l48.69688853 17.29422186c-10.0124448 23.66577813-21.39022187 44.60088853-33.67822187 63.2604448h57.344v207.0755552h-101.94488853v37.77422187h121.0595552v47.78666667l-0.45511147 0.45511146h-120.60444373l-0.45511147-0.45511146c-30.9475552-33.22311147-82.83022187-35.49866667-116.5084448-4.5511104l-5.00622186 5.00622186h-46.42133334v-48.24177813h117.41866667v-37.77422187h-99.66933333v-207.0755552h59.1644448a386.38933333 386.38933333 0 0 0-36.864-60.9848896l46.87644373-15.92888853c13.65333333 19.56977813 26.3964448 40.50488853 36.4088896 62.80533333l-30.94755627 13.65333334h68.26666667c14.5635552-24.576 26.3964448-51.88266667 37.31911147-80.0995552z m-212.08177814 21.84533333v151.552H344.97422187l-6.82666667 66.44622187h98.75911147c0 84.65066667-3.18577813 141.0844448-7.73688854 169.7564448-5.9164448 28.672-30.9475552 44.14577813-76.00355626 47.3315552-12.74311147 0-25.48622187-0.91022187-39.59466667-1.8204448l-13.19822187-47.78666667c12.74311147 1.36533333 26.8515552 2.2755552 40.50488854 2.27555627 24.576 0 38.6844448-7.73688853 41.87022293-23.66577814 3.64088853-15.92888853 5.46133333-49.60711147 5.46133333-101.94488853H285.35466667l13.65333333-154.28266667h83.28533333v-63.71555626H289.90577813v-43.69066667h143.8151104v-0.4551104z",
  "p-id": "7052"
}, null, -1));
const _hoisted_178 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M792.9856 171.40622187a182.0444448 182.0444448 0 0 1 181.8624 172.94222293l0.1820448 9.10222187v113.77777813a45.51111147 45.51111147 0 0 1-90.7036448 5.27928854l-0.31857813-5.3248V353.45066667a91.02222187 91.02222187 0 0 0-84.1955552-90.7491552l-6.82666667-0.27306667H229.28497813a91.02222187 91.02222187 0 0 0-90.79466666 84.24106667l-0.22755627 6.82666667v427.30382186a91.02222187 91.02222187 0 0 0 84.19555627 90.79466667l6.82666666 0.2275552h300.55537707a45.51111147 45.51111147 0 0 1 5.3248 90.7036448l-5.3248 0.31857813H229.28497813a182.0444448 182.0444448 0 0 1-181.8168896-172.94222293l-0.2275552-9.10222187v-427.34933333a182.0444448 182.0444448 0 0 1 172.94222187-181.81688853l9.10222293-0.22755627h563.70062187z",
  "p-id": "7053"
}, null, -1));
const _hoisted_179 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M286.76551147 48.2076448a45.51111147 45.51111147 0 0 1 60.07466666-3.77742293l4.27804374 3.77742293 136.53333333 136.53333334a45.51111147 45.51111147 0 0 1-60.07466667 68.17564373l-4.27804373-3.77742187-136.53333333-136.53333333a45.51111147 45.51111147 0 0 1 0-64.39822187z",
  "p-id": "7054"
}, null, -1));
const _hoisted_180 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M715.20711147 48.2076448a45.51111147 45.51111147 0 0 0-60.07466667-3.77742293l-4.2780448 3.77742293-136.53333333 136.53333334a45.51111147 45.51111147 0 0 0 60.07466666 68.17564373l4.2780448-3.77742187 136.53333334-136.53333333a45.51111147 45.51111147 0 0 0 0-64.39822187z",
  "p-id": "7055"
}, null, -1));
const _hoisted_181 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M896.3868448 596.02488854a45.51111147 45.51111147 0 0 1 69.95057707 57.9356448l-3.64088854 4.41457813-245.39591146 260.9152a45.51111147 45.51111147 0 0 1-61.53102187 4.36906667l-4.36906667-3.95946667-118.01031146-122.33386667a45.51111147 45.51111147 0 0 1 61.30346666-67.03786666l4.23253334 3.86844373 84.7872 87.88195627 212.67342293-226.0536896z",
  fill: "#FF6699",
  "p-id": "7056"
}, null, -1));
const _hoisted_182 = [_hoisted_177, _hoisted_178, _hoisted_179, _hoisted_180, _hoisted_181];
const _hoisted_183 = {
  key: 1,
  t: "1700488288201",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "7204",
  width: "100%",
  height: "100%"
};
const _hoisted_184 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M673.10933333 432.64H616.6755552v40.50488854h56.43377813v-40.50488854z m-106.95111146 0h-53.7031104v40.50488854h53.7031104v-40.50488854z m0 82.37511147h-53.7031104v38.22933333h53.7031104v-38.22933333z m106.95111146 0H616.6755552v38.22933333h56.43377813v-38.22933333z m-27.30666666-206.16533333l48.69688853 17.29422186c-10.0124448 23.66577813-21.39022187 44.60088853-33.67822187 63.2604448h57.344v207.0755552h-101.94488853v37.77422187h44.60088853l-15.01866666 48.24177813h-29.58222187l-0.45511147-0.45511146-121.51466666 0.45511146h-46.42133334v-48.24177813h117.41866667v-37.77422187h-99.66933333v-207.0755552h59.1644448a386.38933333 386.38933333 0 0 0-36.864-60.9848896l46.87644373-15.92888853c13.65333333 19.56977813 26.3964448 40.50488853 36.4088896 62.80533333l-30.94755627 13.65333334h68.26666667c14.5635552-24.576 26.3964448-51.88266667 37.31911147-80.0995552z m-212.08177814 21.84533333v151.552H344.97422187l-6.82666667 66.44622187h98.75911147c0 84.65066667-3.18577813 141.0844448-7.73688854 169.7564448-5.9164448 28.672-30.9475552 44.14577813-76.00355626 47.3315552-12.74311147 0-25.48622187-0.91022187-39.59466667-1.8204448l-13.19822187-47.78666667c12.74311147 1.36533333 26.8515552 2.2755552 40.50488854 2.27555627 24.576 0 38.6844448-7.73688853 41.87022293-23.66577814 3.64088853-15.92888853 5.46133333-49.60711147 5.46133333-101.94488853H285.35466667l13.65333333-154.28266667h83.28533333v-63.71555626H289.90577813v-43.69066667h143.8151104v-0.4551104z",
  "p-id": "7205"
}, null, -1));
const _hoisted_185 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M792.9856 171.40622187a182.0444448 182.0444448 0 0 1 181.8624 172.94222293l0.1820448 9.10222187v79.18933333a45.51111147 45.51111147 0 0 1-90.7036448 5.3248l-0.31857813-5.3248v-79.18933333a91.02222187 91.02222187 0 0 0-84.1955552-90.7491552l-6.82666667-0.27306667H229.28497813a91.02222187 91.02222187 0 0 0-90.79466666 84.24106667l-0.22755627 6.82666667v427.30382186a91.02222187 91.02222187 0 0 0 84.19555627 90.79466667l6.82666666 0.2275552h300.55537707a45.51111147 45.51111147 0 0 1 5.3248 90.7036448l-5.3248 0.31857813H229.28497813a182.0444448 182.0444448 0 0 1-181.8168896-172.94222293l-0.2275552-9.10222187v-427.34933333a182.0444448 182.0444448 0 0 1 172.94222187-181.81688853l9.10222293-0.22755627h563.70062187z",
  "p-id": "7206"
}, null, -1));
const _hoisted_186 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M286.76551147 48.2076448a45.51111147 45.51111147 0 0 1 60.07466666-3.77742293l4.27804374 3.77742293 136.53333333 136.53333334a45.51111147 45.51111147 0 0 1-60.07466667 68.17564373l-4.27804373-3.77742187-136.53333333-136.53333333a45.51111147 45.51111147 0 0 1 0-64.39822187z",
  "p-id": "7207"
}, null, -1));
const _hoisted_187 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M715.20711147 48.2076448a45.51111147 45.51111147 0 0 0-60.07466667-3.77742293l-4.2780448 3.77742293-136.53333333 136.53333334a45.51111147 45.51111147 0 0 0 60.07466666 68.17564373l4.2780448-3.77742187 136.53333334-136.53333333a45.51111147 45.51111147 0 0 0 0-64.39822187z",
  "p-id": "7208"
}, null, -1));
const _hoisted_188 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M785.06666667 490.66666667a227.5555552 227.5555552 0 1 0 0 455.11111147 227.5555552 227.5555552 0 0 0 0-455.11111147z m0 91.02222187a136.53333333 136.53333333 0 1 1 0 273.06666666 136.53333333 136.53333333 0 0 1 0-273.06666666z",
  "p-id": "7209"
}, null, -1));
const _hoisted_189 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M870.94613333 571.99502187a45.51111147 45.51111147 0 0 1 66.7648 61.57653333l-3.8684448 4.18702294-229.28497706 219.31804373a45.51111147 45.51111147 0 0 1-66.7648-61.57653333l3.86844373-4.18702187 229.28497813-219.3635552z",
  "p-id": "7210"
}, null, -1));
const _hoisted_190 = [_hoisted_184, _hoisted_185, _hoisted_186, _hoisted_187, _hoisted_188, _hoisted_189];
const _hoisted_191 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1700490442936",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "3841",
  width: "100%",
  height: "100%"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M167.25546667 293.9904h-54.61333333c-40.84622222 0-73.95555555-33.10933333-73.95555555-73.95555555s33.10933333-73.95555555 73.95555555-73.95555556h54.61333333c40.84622222 0 73.95555555 33.10933333 73.95555555 73.95555556s-33.10933333 73.95555555-73.95555555 73.95555555zM732.73102222 293.9904h-366.36444444c-40.84622222 0-73.95555555-33.10933333-73.95555555-73.95555555s33.10933333-73.95555555 73.95555555-73.95555556h366.36444444c40.84622222 0 73.95555555 33.10933333 73.95555557 73.95555556s-33.10933333 73.95555555-73.95555557 73.95555555zM367.50435555 589.81262222h-254.86222221c-40.84622222 0-73.95555555-33.10933333-73.95555555-73.95555555s33.10933333-73.95555555 73.95555555-73.95555556h254.86222221c40.84622222 0 73.95555555 33.10933333 73.95555556 73.95555556s-33.10933333 73.95555555-73.95555556 73.95555555zM195.69991111 884.49706667h-83.05777777c-40.84622222 0-73.95555555-33.10933333-73.95555555-73.95555556s33.10933333-73.95555555 73.95555555-73.95555556h83.05777777c40.84622222 0 73.95555555 33.10933333 73.95555556 73.95555556s-33.10933333 73.95555555-73.95555556 73.95555556zM392.53546667 884.49706667h-1.13777778c-40.84622222 0-73.95555555-33.10933333-73.95555556-73.95555556s33.10933333-73.95555555 73.95555556-73.95555556h1.13777778c40.84622222 0 73.95555555 33.10933333 73.95555555 73.95555556s-33.10933333 73.95555555-73.95555555 73.95555556zM995.83075556 599.1424l-106.26844445-184.06968889a67.34392889 67.34392889 0 0 0-58.33386666-33.67822222h-212.5368889a67.35758222 67.35758222 0 0 0-58.33386666 33.67822222l-106.26844443 184.06968889a67.38488889 67.38488889 0 0 0 0 67.35644445l106.26844443 184.06968888a67.34392889 67.34392889 0 0 0 58.33386666 33.67822222h212.54826667c24.064 0 46.29617778-12.83413333 58.33386667-33.67822222l106.26844445-184.06968888a67.35644445 67.35644445 0 0 0-0.01137778-67.35644445z m-270.87075555 108.97635555c-41.58577778 0-75.29813333-33.71235555-75.29813334-75.29813333 0-41.58577778 33.71235555-75.29813333 75.29813334-75.29813333 41.58577778 0 75.29813333 33.71235555 75.29813332 75.29813333 0 41.58577778-33.71235555 75.29813333-75.29813332 75.29813333z",
  "p-id": "3842"
})], -1));
const _hoisted_192 = {
  class: "player-dm-setting-wrap"
};
const _hoisted_193 = {
  class: "player-dm-setting-box v-ui v-ui-panel v-ui-dark"
};
const _hoisted_194 = {
  class: "v-ui-area"
};
const _hoisted_195 = {
  class: "v-ui-panel-wrap",
  style: {
    "width": "320px",
    "height": "78px"
  }
};
const _hoisted_196 = {
  class: "v-ui-panel-move",
  style: {
    "width": "586px",
    "transform": "translateX(0px)"
  }
};
const _hoisted_197 = {
  class: "v-ui-panel-item v-ui-panel-item-active",
  style: {
    "width": "320px",
    "height": "78px"
  }
};
const _hoisted_198 = {
  class: "player-dm-setting-left"
};
const _hoisted_199 = {
  class: "player-dm-setting-left-opacity"
};
const _hoisted_200 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "player-dm-setting-left-title"
}, "不透明度", -1));
const _hoisted_201 = {
  class: "player-dm-setting-left-content"
};
const _hoisted_202 = {
  class: "v-ui",
  style: {
    "height": "12px"
  }
};
const _hoisted_203 = {
  class: "v-ui-area"
};
const _hoisted_204 = {
  class: "player-dm-setting-left-value"
};
const _hoisted_205 = {
  class: "player-dm-setting-left-speed"
};
const _hoisted_206 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "player-dm-setting-left-title"
}, "弹幕速度", -1));
const _hoisted_207 = {
  class: "player-dm-setting-left-content",
  style: {
    "height": "22px"
  }
};
const _hoisted_208 = {
  class: "dm-speed-items"
};
const _hoisted_209 = {
  class: "player-dm-inputbar"
};
const _hoisted_210 = {
  class: "player-video-inputbar-wrap"
};
const _hoisted_211 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1700493799646",
  class: "icon player-dm-btn-font-icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "6734",
  width: "20",
  height: "20"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M220.36510341 728.70570667h139.03341036l57.78818844-140.5868563h226.4147437l54.9143135 140.5868563h146.25693392L584.41515614 45.96622222H480.64496829l-260.27986488 682.73948445zM609.81399703 473.94057482H447.01286399L530.43291021 234.70990222 609.81399703 474.01824711zM166.30518518 819.65996563v136.54789689h728.17777778V819.58229333H166.30518518z",
  "p-id": "6735"
})], -1));
const _hoisted_212 = {
  class: "player-mode-selection-container"
};
const _hoisted_213 = {
  class: "player-mode-selection-panel"
};
const _hoisted_214 = {
  class: "player-mode-selection-row"
};
const _hoisted_215 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row-title"
}, "字号", -1));
const _hoisted_216 = {
  class: "row-selection"
};
const _hoisted_217 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "selection-name"
}, "小", -1));
const _hoisted_218 = [_hoisted_217];
const _hoisted_219 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "selection-name"
}, "标准", -1));
const _hoisted_220 = [_hoisted_219];
const _hoisted_221 = {
  class: "player-mode-selection-row"
};
const _hoisted_222 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row-title"
}, "模式", -1));
const _hoisted_223 = {
  class: "row-selection"
};
const _hoisted_224 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "selection-icon"
}, [/*#__PURE__*/_createElementVNode("svg", {
  t: "1700749596256",
  class: "icon",
  viewBox: "0 0 1192 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "3991"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M1067.17373094 1051.22149218H111.25014969C67.48417906 1051.22149218 32 1015.52238843 32 971.42686593V175.80179062C32 131.72776124 67.81373094 95.99999999 111.25014969 95.99999999h955.92358125c43.77313406 0 79.25731312 35.69910469 79.25731406 79.80179062v795.62507532c0 44.06686594-35.82089531 79.79462719-79.25731406 79.79462625z m-119.74925344-358.208955H390.208955a39.83283563 39.83283563 0 0 0-39.80417906 39.80417906A39.81850781 39.81850781 0 0 0 390.208955 772.61373093h557.2155225a39.81134344 39.81134344 0 0 0 39.79701469-39.79701469 39.81850781 39.81850781 0 0 0-39.79701469-39.80417906z m39.79701469-119.39820844a39.81850781 39.81850781 0 0 0-39.79701469-39.80417906H748.41791a39.82567125 39.82567125 0 0 0-39.80417906 39.80417906A39.81850781 39.81850781 0 0 0 748.41791 613.41134343h199.0065675a39.81134344 39.81134344 0 0 0 39.79701469-39.79701469z m-398.00596969-39.80417906H509.61432875a39.82567125 39.82567125 0 0 0-39.80417906 39.80417906 39.81850781 39.81850781 0 0 0 39.80417906 39.79701469h79.60119375a39.81134344 39.81134344 0 0 0 39.79701469-39.79701469 39.81850781 39.81850781 0 0 0-39.79701469-39.80417906z m398.00596969-119.40537375a39.81134344 39.81134344 0 0 0-39.79701469-39.79701469h-716.41791a39.81850781 39.81850781 0 0 0-39.80417906 39.79701469A39.82567125 39.82567125 0 0 0 231.0065675 454.20895499h716.41791a39.81850781 39.81850781 0 0 0 39.79701469-39.80417906z",
  "p-id": "3992"
})])], -1));
const _hoisted_225 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "selection-name"
}, "滚动", -1));
const _hoisted_226 = [_hoisted_224, _hoisted_225];
const _hoisted_227 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "selection-icon"
}, [/*#__PURE__*/_createElementVNode("svg", {
  t: "1700749716948",
  class: "icon",
  viewBox: "0 0 1192 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4232"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M1066.82268688 95.99999999c43.93791 0 79.60835812 35.67044813 79.60835812 79.60119375v796.01910469c0 43.93791-35.67044813 79.60119375-79.60835812 79.60119375H111.60119375C67.67044813 1051.22149218 32 1015.55820937 32 971.62029843V175.60119374C32 131.67044812 67.67044813 95.99999999 111.60119375 95.99999999h955.22149312zM668.81671625 374.60776124H231.0065675a39.81850781 39.81850781 0 0 0-39.80417906 39.79701469A39.82567125 39.82567125 0 0 0 231.0065675 454.20895499h437.81014875a39.81850781 39.81850781 0 0 0 39.79701469-39.80417906 39.81134344 39.81134344 0 0 0-39.79701469-39.79701469z m238.80358219 0h-79.60119375a39.81134344 39.81134344 0 0 0-39.79701469 39.79701469A39.81850781 39.81850781 0 0 0 828.01910469 454.20895499h79.60119375a39.82567125 39.82567125 0 0 0 39.80417906-39.80417906 39.81850781 39.81850781 0 0 0-39.80417906-39.79701469z m79.60119375-119.40537281a39.81134344 39.81134344 0 0 0-39.79701469-39.79701563h-716.41791a39.81850781 39.81850781 0 0 0-39.80417906 39.79701563 39.83283563 39.83283563 0 0 0 39.80417906 39.80417906h716.41791a39.81850781 39.81850781 0 0 0 39.79701469-39.80417906z",
  "p-id": "4233"
})])], -1));
const _hoisted_228 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "selection-name"
}, "顶部", -1));
const _hoisted_229 = [_hoisted_227, _hoisted_228];
const _hoisted_230 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "selection-icon"
}, [/*#__PURE__*/_createElementVNode("svg", {
  t: "1700749744954",
  class: "icon",
  viewBox: "0 0 1192 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4427"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M1066.82985031 95.99999999c43.93791 0 79.59403031 35.66328375 79.59403031 79.60119375v796.01910469c0 43.94507438-35.65611938 79.60119375-79.59403031 79.60119375H111.59403031C67.66328375 1051.22149218 32 1015.5653728 32 971.6274628V175.5940303C32 131.66328374 67.66328375 95.99999999 111.60119375 95.99999999h955.22865656z m-119.40537281 756.22209h-716.41791a39.81850781 39.81850781 0 0 0-39.80417906 39.79701469 39.81850781 39.81850781 0 0 0 39.80417906 39.80417906h716.41791a39.81850781 39.81850781 0 0 0 39.79701469-39.80417906 39.81850781 39.81850781 0 0 0-39.79701469-39.79701469zM668.81671625 693.01253718H231.0065675a39.81850781 39.81850781 0 0 0-39.80417906 39.80417906 39.81850781 39.81850781 0 0 0 39.80417906 39.80417906h437.81014875a39.81850781 39.81850781 0 0 0 39.80417906-39.80417906 39.81850781 39.81850781 0 0 0-39.80417906-39.80417906z m238.80358219 0h-79.59402938a39.81850781 39.81850781 0 0 0-39.80417906 39.80417906 39.81850781 39.81850781 0 0 0 39.79701469 39.80417906h79.60119375a39.81850781 39.81850781 0 0 0 39.80417906-39.80417906 39.81850781 39.81850781 0 0 0-39.80417906-39.80417906z",
  "p-id": "4428"
})])], -1));
const _hoisted_231 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "selection-name"
}, "底部", -1));
const _hoisted_232 = [_hoisted_230, _hoisted_231];
const _hoisted_233 = {
  class: "player-mode-selection-row"
};
const _hoisted_234 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row-title"
}, "颜色", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LoadingBuff = _resolveComponent("LoadingBuff");
  const _component_PlayerLoading = _resolveComponent("PlayerLoading");
  const _component_PlayerProgress = _resolveComponent("PlayerProgress");
  const _component_SliderRow = _resolveComponent("SliderRow");
  const _component_ColorPicker = _resolveComponent("ColorPicker");
  const _component_el_input = _resolveComponent("el-input");
  const _component_SliderColumn = _resolveComponent("SliderColumn");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  return _openBlock(), _createElementBlock("div", {
    id: "playerWrap",
    class: "player-wrap",
    style: _normalizeStyle(`height: ${$data.wrapSize.height}px; width: ${$data.wrapSize.width}px;`)
  }, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: _normalizeClass(["player-video-area", {
      'state-paused': $data.pause,
      'state-buff': $data.buff && !$data.pause
    }]),
    id: "video-area",
    "data-screen": $data.screenType,
    "data-ctrl-hidden": $data.ctrlHidden,
    onMouseleave: _cache[59] || (_cache[59] = $event => $data.ctrlHidden = true)
  }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("video", {
    ref: "videoPlayer",
    src: $props.videoUrl,
    onLoadedmetadata: _cache[0] || (_cache[0] = (...args) => $options.videoCanPlay && $options.videoCanPlay(...args)),
    onTimeupdate: _cache[1] || (_cache[1] = (...args) => $options.timeUpdate && $options.timeUpdate(...args)),
    onProgress: _cache[2] || (_cache[2] = (...args) => $options.updateBufferingBar && $options.updateBufferingBar(...args)),
    onWaiting: _cache[3] || (_cache[3] = $event => $data.buff = true),
    onCanplay: _cache[4] || (_cache[4] = $event => $data.buff = false),
    onEnded: _cache[5] || (_cache[5] = (...args) => $options.ended && $options.ended(...args)),
    loop: $data.setting.loop
  }, null, 40, _hoisted_7)])]), _createElementVNode("div", {
    class: _normalizeClass(["player-row-dm-wrap", {
      'dm-show': $data.danmuOpen
    }])
  }, null, 2), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createVNode(_component_LoadingBuff)]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("span", null, _toDisplayString($data.bufferSpeed) + "KB/s", 1)])]), _createElementVNode("div", {
    class: "player-loading-panel",
    style: _normalizeStyle($data.canPlay ? 'display: none;' : 'display: block;')
  }, [_createVNode(_component_PlayerLoading)], 4), _createElementVNode("div", {
    class: "player-masking",
    onMousemove: _cache[6] || (_cache[6] = (...args) => $options.showCtrl && $options.showCtrl(...args)),
    onClick: _cache[7] || (_cache[7] = (...args) => $options.handleClick && $options.handleClick(...args)),
    onDblclick: _cache[8] || (_cache[8] = (...args) => $options.handleDblClick && $options.handleDblClick(...args))
  }, null, 32), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString($props.title), 1), $props.user.id ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", {
    class: "player-follow",
    onMouseenter: _cache[9] || (_cache[9] = (...args) => $options.showCtrlAlweys && $options.showCtrlAlweys(...args))
  }, [_createElementVNode("img", {
    class: "player-follow-face",
    src: $props.user.avatar_url,
    alt: ""
  }, null, 8, _hoisted_17), _hoisted_18, _hoisted_19], 32)])) : _createCommentVNode("", true)])]), _createElementVNode("div", {
    class: "player-control-wrap",
    onMouseenter: _cache[58] || (_cache[58] = (...args) => $options.showCtrlAlweys && $options.showCtrlAlweys(...args))
  }, [_hoisted_20, _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_PlayerProgress, {
    currentPer: $data.currentPer,
    bufferPer: $data.bufferPer,
    onChangeCurrent: $options.changeCurrentPer
  }, null, 8, ["currentPer", "bufferPer", "onChangeCurrent"])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [false ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", {
    class: "player-ctrl-btn-icon player-ctrl-play-play",
    style: _normalizeStyle($data.pause ? '' : 'display: none;'),
    onClick: _cache[10] || (_cache[10] = (...args) => $options.playVideo && $options.playVideo(...args))
  }, _hoisted_30, 4), _createElementVNode("div", {
    class: "player-ctrl-btn-icon player-ctrl-play-pause",
    style: _normalizeStyle(!$data.pause ? '' : 'display: none;'),
    onClick: _cache[11] || (_cache[11] = (...args) => $options.pauseVideo && $options.pauseVideo(...args))
  }, _hoisted_32, 4)]), false ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("span", _hoisted_38, _toDisplayString($options.handleTime($data.currentTime)), 1), _hoisted_39, _createElementVNode("span", _hoisted_40, _toDisplayString($options.handleTime($props.duration)), 1)])])]), _createElementVNode("div", _hoisted_41, [$data.screenType !== 'normal' ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", null, [_createElementVNode("div", {
    class: "player-dm-switch player-dm-outside",
    onClick: _cache[12] || (_cache[12] = (...args) => $options.changeDanmu && $options.changeDanmu(...args)),
    onMouseenter: _cache[13] || (_cache[13] = $event => $data.dmTips = true),
    onMouseleave: _cache[14] || (_cache[14] = $event => $data.dmTips = false)
  }, [$data.danmuOpen ? (_openBlock(), _createElementBlock("svg", _hoisted_44, _hoisted_50)) : (_openBlock(), _createElementBlock("svg", _hoisted_51, _hoisted_58))], 32)]), _createElementVNode("div", {
    class: "player-dm-setting player-dm-outside",
    onMouseenter: _cache[19] || (_cache[19] = $event => $options.enterBtn('player-dm-setting', 0)),
    onMouseleave: _cache[20] || (_cache[20] = $event => $options.leaveBtn('player-dm-setting', 0))
  }, [_hoisted_59, _createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_createElementVNode("div", _hoisted_67, [_hoisted_68, _createElementVNode("div", _hoisted_69, [_createElementVNode("div", _hoisted_70, [_createElementVNode("div", _hoisted_71, [_createVNode(_component_SliderRow, {
    class: "player-dm-setting-left-progress",
    currentPer: $data.dmSetting.opacity / 100,
    sliderWidth: 182,
    order: $data.dmOpacityOrder,
    "onUpdate:order": _cache[15] || (_cache[15] = $event => $data.dmOpacityOrder = $event),
    onChangeCurrent: $options.changeDmOpacity
  }, null, 8, ["currentPer", "order", "onChangeCurrent"]), _createElementVNode("div", _hoisted_72, _toDisplayString($data.dmSetting.opacity) + "%", 1)])])])]), _createElementVNode("div", _hoisted_73, [_hoisted_74, _createElementVNode("div", _hoisted_75, [_createElementVNode("div", _hoisted_76, [_createElementVNode("div", {
    class: _normalizeClass(["dm-speed-item", {
      'active': $data.dmSetting.dmSpeed === 1
    }]),
    onClick: _cache[16] || (_cache[16] = $event => $data.dmSetting.dmSpeed = 1)
  }, "慢 ", 2), _createElementVNode("div", {
    class: _normalizeClass(["dm-speed-item", {
      'active': $data.dmSetting.dmSpeed === 2
    }]),
    onClick: _cache[17] || (_cache[17] = $event => $data.dmSetting.dmSpeed = 2)
  }, "适中 ", 2), _createElementVNode("div", {
    class: _normalizeClass(["dm-speed-item", {
      'active': $data.dmSetting.dmSpeed === 4
    }]),
    onClick: _cache[18] || (_cache[18] = $event => $data.dmSetting.dmSpeed = 4)
  }, "快 ", 2)])])])])])])])])])])], 32), $data.showDmInput ? (_openBlock(), _createElementBlock("div", _hoisted_77, [_createElementVNode("div", _hoisted_78, [_createElementVNode("div", {
    class: "player-dm-btn-font player-dm-outside",
    onMouseenter: _cache[27] || (_cache[27] = $event => $options.enterBtn('player-dm-btn-font', 1)),
    onMouseleave: _cache[28] || (_cache[28] = $event => $options.leaveBtn('player-dm-btn-font', 1))
  }, [_hoisted_79, _createElementVNode("div", _hoisted_80, [_createElementVNode("div", _hoisted_81, [_createElementVNode("div", _hoisted_82, [_hoisted_83, _createElementVNode("div", _hoisted_84, [_createElementVNode("div", {
    class: _normalizeClass(["selection-span type-fontsize", {
      'active': $data.dmStyle.fontsize === 18
    }]),
    onClick: _cache[21] || (_cache[21] = $event => $data.dmStyle.fontsize = 18)
  }, _hoisted_86, 2), _createElementVNode("div", {
    class: _normalizeClass(["selection-span type-fontsize", {
      'active': $data.dmStyle.fontsize === 25
    }]),
    onClick: _cache[22] || (_cache[22] = $event => $data.dmStyle.fontsize = 25)
  }, _hoisted_88, 2)])]), _createElementVNode("div", _hoisted_89, [_hoisted_90, _createElementVNode("div", _hoisted_91, [_createElementVNode("div", {
    class: _normalizeClass(["selection-span type-mode", {
      'active': $data.dmStyle.mode === 1
    }]),
    onClick: _cache[23] || (_cache[23] = $event => $data.dmStyle.mode = 1)
  }, _hoisted_94, 2), _createElementVNode("div", {
    class: _normalizeClass(["selection-span type-mode", {
      'active': $data.dmStyle.mode === 2
    }]),
    onClick: _cache[24] || (_cache[24] = $event => $data.dmStyle.mode = 2)
  }, _hoisted_97, 2), _createElementVNode("div", {
    class: _normalizeClass(["selection-span type-mode", {
      'active': $data.dmStyle.mode === 3
    }]),
    onClick: _cache[25] || (_cache[25] = $event => $data.dmStyle.mode = 3)
  }, _hoisted_100, 2)])]), _createElementVNode("div", _hoisted_101, [_hoisted_102, _createVNode(_component_ColorPicker, {
    class: "row-selection",
    color: $data.dmStyle.color,
    "onUpdate:color": _cache[26] || (_cache[26] = $event => $data.dmStyle.color = $event)
  }, null, 8, ["color"])])])])], 32), _createVNode(_component_el_input, {
    type: "text",
    maxlength: "100",
    placeholder: "发个友善的弹幕见证当下",
    class: "player-dm-input",
    modelValue: $data.input,
    "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => $data.input = $event)
  }, null, 8, ["modelValue"])]), _createElementVNode("div", {
    class: "player-dm-btn-send",
    onClick: _cache[30] || (_cache[30] = (...args) => $options.sendDm && $options.sendDm(...args))
  }, "发送")])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_103, [false ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "player-ctrl-btn player-ctrl-quality",
    onMouseenter: _cache[31] || (_cache[31] = $event => $options.enterBtn('player-ctrl-quality', 2)),
    onMouseleave: _cache[32] || (_cache[32] = $event => $options.leaveBtn('player-ctrl-quality', 2))
  }, _hoisted_105, 32)) : _createCommentVNode("", true), false ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "player-ctrl-btn player-ctrl-eplist",
    onMouseenter: _cache[33] || (_cache[33] = $event => $options.enterBtn('player-ctrl-eplist', 3)),
    onMouseleave: _cache[34] || (_cache[34] = $event => $options.leaveBtn('player-ctrl-eplist', 3))
  }, _hoisted_107, 32)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "player-ctrl-btn player-ctrl-playbackrate",
    onMouseenter: _cache[41] || (_cache[41] = $event => $options.enterBtn('player-ctrl-playbackrate', 4)),
    onMouseleave: _cache[42] || (_cache[42] = $event => $options.leaveBtn('player-ctrl-playbackrate', 4))
  }, [_createElementVNode("div", _hoisted_108, _toDisplayString($data.playbackrate), 1), _createElementVNode("ul", _hoisted_109, [_createElementVNode("li", {
    class: _normalizeClass(["player-ctrl-playbackrate-menu-item", {
      'state-active': $data.playbackrate === '2.0x'
    }]),
    onClick: _cache[35] || (_cache[35] = $event => $options.changePlaybackRate(2.0))
  }, "2.0x ", 2), _createElementVNode("li", {
    class: _normalizeClass(["player-ctrl-playbackrate-menu-item", {
      'state-active': $data.playbackrate === '1.5x'
    }]),
    onClick: _cache[36] || (_cache[36] = $event => $options.changePlaybackRate(1.5))
  }, "1.5x ", 2), _createElementVNode("li", {
    class: _normalizeClass(["player-ctrl-playbackrate-menu-item", {
      'state-active': $data.playbackrate === '1.25x'
    }]),
    onClick: _cache[37] || (_cache[37] = $event => $options.changePlaybackRate(1.25))
  }, "1.25x ", 2), _createElementVNode("li", {
    class: _normalizeClass(["player-ctrl-playbackrate-menu-item", {
      'state-active': $data.playbackrate === '倍速'
    }]),
    onClick: _cache[38] || (_cache[38] = $event => $options.changePlaybackRate(1.0))
  }, "1.0x ", 2), _createElementVNode("li", {
    class: _normalizeClass(["player-ctrl-playbackrate-menu-item", {
      'state-active': $data.playbackrate === '0.75x'
    }]),
    onClick: _cache[39] || (_cache[39] = $event => $options.changePlaybackRate(0.75))
  }, "0.75x ", 2), _createElementVNode("li", {
    class: _normalizeClass(["player-ctrl-playbackrate-menu-item", {
      'state-active': $data.playbackrate === '0.5x'
    }]),
    onClick: _cache[40] || (_cache[40] = $event => $options.changePlaybackRate(0.5))
  }, "0.5x ", 2)])], 32), _createElementVNode("div", {
    class: "player-ctrl-btn player-ctrl-setting",
    onMouseenter: _cache[46] || (_cache[46] = $event => $options.enterBtn('player-ctrl-setting', 5)),
    onMouseleave: _cache[47] || (_cache[47] = $event => $options.leaveBtn('player-ctrl-setting', 5))
  }, [_hoisted_110, _createElementVNode("div", _hoisted_111, [_createElementVNode("div", _hoisted_112, [_createElementVNode("div", _hoisted_113, [_createElementVNode("div", _hoisted_114, [_createElementVNode("div", _hoisted_115, [_createElementVNode("div", _hoisted_116, [_createElementVNode("div", _hoisted_117, [_createElementVNode("div", {
    class: _normalizeClass(["player-ctrl-setting-loop v-ui v-ui-switch", {
      'checked': $data.setting.loop
    }]),
    onClick: _cache[43] || (_cache[43] = $event => $options.changeSetting(1))
  }, _hoisted_119, 2), _createElementVNode("div", {
    class: _normalizeClass(["player-ctrl-setting-autoplay v-ui v-ui-switch", {
      'checked': $data.setting.autoplay
    }]),
    onClick: _cache[44] || (_cache[44] = $event => $options.changeSetting(2))
  }, _hoisted_121, 2), _createElementVNode("div", {
    class: _normalizeClass(["player-ctrl-setting-autonext v-ui v-ui-switch", {
      'checked': $data.setting.autonext
    }]),
    onClick: _cache[45] || (_cache[45] = $event => $options.changeSetting(3))
  }, _hoisted_123, 2)])])])])])])])], 32), _createElementVNode("div", {
    class: "player-ctrl-btn player-ctrl-volume",
    onMouseenter: _cache[50] || (_cache[50] = $event => $options.enterBtn('player-ctrl-volume', 6)),
    onMouseleave: _cache[51] || (_cache[51] = $event => $options.leaveBtn('player-ctrl-volume', 6))
  }, [_createElementVNode("div", {
    class: "player-ctrl-btn-icon",
    onClick: _cache[48] || (_cache[48] = (...args) => $options.changeMutedState && $options.changeMutedState(...args))
  }, [_createElementVNode("span", _hoisted_124, [$data.isMuted ? (_openBlock(), _createElementBlock("svg", _hoisted_125, _hoisted_127)) : (_openBlock(), _createElementBlock("svg", _hoisted_128, _hoisted_132))])]), _createElementVNode("div", _hoisted_133, [_createElementVNode("div", _hoisted_134, _toDisplayString($data.volume), 1), _createVNode(_component_SliderColumn, {
    class: "player-ctrl-volume-progress",
    currentPer: $data.volume / 100,
    sliderHeight: 60,
    order: $data.volumeOrder,
    "onUpdate:order": _cache[49] || (_cache[49] = $event => $data.volumeOrder = $event),
    onChangeCurrent: $options.changeVolume
  }, null, 8, ["currentPer", "order", "onChangeCurrent"])])], 32), _createElementVNode("div", _hoisted_135, [!$data.isMobile ? (_openBlock(), _createBlock(_component_el_tooltip, {
    key: 0,
    visible: $data.fullTips,
    placement: "top-end",
    "show-arrow": false
  }, {
    content: _withCtx(() => [$data.screenType === 'normal' ? (_openBlock(), _createElementBlock("span", _hoisted_136, "进入全屏 (f)")) : _createCommentVNode("", true), $data.screenType === 'full' ? (_openBlock(), _createElementBlock("span", _hoisted_137, "退出全屏 (f)")) : _createCommentVNode("", true)]),
    default: _withCtx(() => [_createElementVNode("div", {
      class: "player-ctrl-btn-icon",
      onClick: _cache[52] || (_cache[52] = (...args) => $options.changeFullScreen && $options.changeFullScreen(...args)),
      onMouseenter: _cache[53] || (_cache[53] = $event => $data.fullTips = true),
      onMouseleave: _cache[54] || (_cache[54] = $event => $data.fullTips = false)
    }, [_createElementVNode("span", _hoisted_138, [$data.screenType === 'normal' ? (_openBlock(), _createElementBlock("svg", _hoisted_139, _hoisted_141)) : _createCommentVNode("", true), $data.screenType === 'full' ? (_openBlock(), _createElementBlock("svg", _hoisted_142, _hoisted_144)) : _createCommentVNode("", true)])], 32)]),
    _: 1
  }, 8, ["visible"])) : $data.isMobile ? (_openBlock(), _createElementBlock("div", _hoisted_145, [_createElementVNode("div", {
    class: "player-ctrl-btn-icon",
    onClick: _cache[55] || (_cache[55] = (...args) => $options.changeFullScreen && $options.changeFullScreen(...args)),
    onMouseenter: _cache[56] || (_cache[56] = $event => $data.fullTips = true),
    onMouseleave: _cache[57] || (_cache[57] = $event => $data.fullTips = false)
  }, [_createElementVNode("span", _hoisted_146, [$data.screenType === 'normal' ? (_openBlock(), _createElementBlock("svg", _hoisted_147, _hoisted_149)) : _createCommentVNode("", true), $data.screenType === 'full' ? (_openBlock(), _createElementBlock("svg", _hoisted_150, _hoisted_152)) : _createCommentVNode("", true)])], 32)])) : _createCommentVNode("", true)])])])])], 32), _createElementVNode("div", _hoisted_153, [_createElementVNode("div", _hoisted_154, [_createElementVNode("div", _hoisted_155, [_createElementVNode("div", {
    class: "player-progress-schedule-buffer",
    style: _normalizeStyle(`transform: scaleX(${$data.bufferPer});`)
  }, null, 4), _createElementVNode("div", {
    class: "player-progress-schedule-current",
    style: _normalizeStyle(`transform: scaleX(${$data.currentPer});`)
  }, null, 4)])])])], 42, _hoisted_4), _createElementVNode("div", _hoisted_156, [_createElementVNode("div", _hoisted_157, [_createElementVNode("div", _hoisted_158, _toDisplayString($props.population) + " 人正在观看，已装填 " + _toDisplayString($data.dmList.length) + " 条弹幕 ", 1)]), _createElementVNode("div", _hoisted_159, [!$data.isMobile ? (_openBlock(), _createBlock(_component_el_tooltip, {
    key: 0,
    visible: $data.dmTips,
    placement: "top",
    "show-arrow": false,
    trigger: "click"
  }, {
    content: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($data.danmuOpen ? '关闭' : '开启') + "弹幕 (d)", 1)]),
    default: _withCtx(() => [_createElementVNode("div", {
      class: "player-dm-switch player-dm-outside",
      onClick: _cache[60] || (_cache[60] = (...args) => $options.changeDanmu && $options.changeDanmu(...args)),
      onMouseenter: _cache[61] || (_cache[61] = $event => $data.dmTips = true),
      onMouseleave: _cache[62] || (_cache[62] = $event => $data.dmTips = false)
    }, [$data.danmuOpen ? (_openBlock(), _createElementBlock("svg", _hoisted_160, _hoisted_166)) : (_openBlock(), _createElementBlock("svg", _hoisted_167, _hoisted_174))], 32)]),
    _: 1
  }, 8, ["visible"])) : $data.isMobile ? (_openBlock(), _createElementBlock("div", _hoisted_175, [_createElementVNode("div", {
    class: "player-dm-switch player-dm-outside",
    onClick: _cache[63] || (_cache[63] = (...args) => $options.changeDanmu && $options.changeDanmu(...args)),
    onMouseenter: _cache[64] || (_cache[64] = $event => $data.dmTips = true),
    onMouseleave: _cache[65] || (_cache[65] = $event => $data.dmTips = false)
  }, [$data.danmuOpen ? (_openBlock(), _createElementBlock("svg", _hoisted_176, _hoisted_182)) : (_openBlock(), _createElementBlock("svg", _hoisted_183, _hoisted_190))], 32)])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "player-dm-setting player-dm-outside",
    onMouseenter: _cache[70] || (_cache[70] = $event => $options.enterBtn('player-dm-setting', 0)),
    onMouseleave: _cache[71] || (_cache[71] = $event => $options.leaveBtn('player-dm-setting', 0))
  }, [_hoisted_191, _createElementVNode("div", _hoisted_192, [_createElementVNode("div", _hoisted_193, [_createElementVNode("div", _hoisted_194, [_createElementVNode("div", _hoisted_195, [_createElementVNode("div", _hoisted_196, [_createElementVNode("div", _hoisted_197, [_createElementVNode("div", _hoisted_198, [_createElementVNode("div", _hoisted_199, [_hoisted_200, _createElementVNode("div", _hoisted_201, [_createElementVNode("div", _hoisted_202, [_createElementVNode("div", _hoisted_203, [_createVNode(_component_SliderRow, {
    class: "player-dm-setting-left-progress",
    currentPer: $data.dmSetting.opacity / 100,
    sliderWidth: 182,
    order: $data.dmOpacityOrder,
    "onUpdate:order": _cache[66] || (_cache[66] = $event => $data.dmOpacityOrder = $event),
    onChangeCurrent: $options.changeDmOpacity
  }, null, 8, ["currentPer", "order", "onChangeCurrent"]), _createElementVNode("div", _hoisted_204, _toDisplayString($data.dmSetting.opacity) + "%", 1)])])])]), _createElementVNode("div", _hoisted_205, [_hoisted_206, _createElementVNode("div", _hoisted_207, [_createElementVNode("div", _hoisted_208, [_createElementVNode("div", {
    class: _normalizeClass(["dm-speed-item", {
      'active': $data.dmSetting.dmSpeed === 1
    }]),
    onClick: _cache[67] || (_cache[67] = $event => $data.dmSetting.dmSpeed = 1)
  }, "慢 ", 2), _createElementVNode("div", {
    class: _normalizeClass(["dm-speed-item", {
      'active': $data.dmSetting.dmSpeed === 2
    }]),
    onClick: _cache[68] || (_cache[68] = $event => $data.dmSetting.dmSpeed = 2)
  }, "适中 ", 2), _createElementVNode("div", {
    class: _normalizeClass(["dm-speed-item", {
      'active': $data.dmSetting.dmSpeed === 4
    }]),
    onClick: _cache[69] || (_cache[69] = $event => $data.dmSetting.dmSpeed = 4)
  }, "快 ", 2)])])])])])])])])])])], 32), _createElementVNode("div", _hoisted_209, [_createElementVNode("div", _hoisted_210, [_createElementVNode("div", {
    class: "player-dm-btn-font player-dm-outside",
    onMouseenter: _cache[78] || (_cache[78] = $event => $options.enterBtn('player-dm-btn-font', 1)),
    onMouseleave: _cache[79] || (_cache[79] = $event => $options.leaveBtn('player-dm-btn-font', 1))
  }, [_hoisted_211, _createElementVNode("div", _hoisted_212, [_createElementVNode("div", _hoisted_213, [_createElementVNode("div", _hoisted_214, [_hoisted_215, _createElementVNode("div", _hoisted_216, [_createElementVNode("div", {
    class: _normalizeClass(["selection-span type-fontsize", {
      'active': $data.dmStyle.fontsize === 18
    }]),
    onClick: _cache[72] || (_cache[72] = $event => $data.dmStyle.fontsize = 18)
  }, _hoisted_218, 2), _createElementVNode("div", {
    class: _normalizeClass(["selection-span type-fontsize", {
      'active': $data.dmStyle.fontsize === 25
    }]),
    onClick: _cache[73] || (_cache[73] = $event => $data.dmStyle.fontsize = 25)
  }, _hoisted_220, 2)])]), _createElementVNode("div", _hoisted_221, [_hoisted_222, _createElementVNode("div", _hoisted_223, [_createElementVNode("div", {
    class: _normalizeClass(["selection-span type-mode", {
      'active': $data.dmStyle.mode === 1
    }]),
    onClick: _cache[74] || (_cache[74] = $event => $data.dmStyle.mode = 1)
  }, _hoisted_226, 2), _createElementVNode("div", {
    class: _normalizeClass(["selection-span type-mode", {
      'active': $data.dmStyle.mode === 2
    }]),
    onClick: _cache[75] || (_cache[75] = $event => $data.dmStyle.mode = 2)
  }, _hoisted_229, 2), _createElementVNode("div", {
    class: _normalizeClass(["selection-span type-mode", {
      'active': $data.dmStyle.mode === 3
    }]),
    onClick: _cache[76] || (_cache[76] = $event => $data.dmStyle.mode = 3)
  }, _hoisted_232, 2)])]), _createElementVNode("div", _hoisted_233, [_hoisted_234, _createVNode(_component_ColorPicker, {
    class: "row-selection",
    color: $data.dmStyle.color,
    "onUpdate:color": _cache[77] || (_cache[77] = $event => $data.dmStyle.color = $event)
  }, null, 8, ["color"])])])])], 32), _createVNode(_component_el_input, {
    type: "text",
    maxlength: "100",
    placeholder: "发个友善的弹幕见证当下",
    class: "player-dm-input",
    modelValue: $data.input,
    "onUpdate:modelValue": _cache[80] || (_cache[80] = $event => $data.input = $event)
  }, null, 8, ["modelValue"])]), _createElementVNode("div", {
    class: "player-dm-btn-send",
    onClick: _cache[81] || (_cache[81] = (...args) => $options.sendDm && $options.sendDm(...args))
  }, "发送")])])])])])], 4);
}